module.exports = __webpack_public_path__ + "static/widgets_3-0cdb3081e6d1fd6238ef69a0323eb3d1.png";